import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=71eb0ec1&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71eb0ec1"]])

export default __exports__